import { z } from 'zod';
export const getUserTradingRankPathSchema = z.object({
    subdomain: z.string(),
    tradingCompetitionId: z.string(),
    userId: z.string(),
});
export const getUserTradingRankInputSchema = getUserTradingRankPathSchema;
export const getUserTradingRankOutputSchema = z
    .object({
    userId: z.string(),
    name: z.string(),
    avatar: z.string().nullable(),
    rank: z.number(),
    volume: z.number(),
    expectedReward: z.number(),
    currentHourVolume: z.number(),
    hourlyVolumeLimit: z.number(),
    remainingHourlyLimit: z.number(),
    dailyVolumeLimit: z.number(),
    remainingDailyLimit: z.number(),
})
    .nullable();
